import { Injectable } from '@angular/core';
import { Selector, State } from '@ngxs/store';
import { ChildStateModel } from './child-state.model';

@State<ChildStateModel>({
	name: 'childState',
	defaults: {
		childForm: {
			model: {
				children: []
			}
		}
	} as ChildStateModel
})
@Injectable()
export class ChildState {
	@Selector()
	static children(state: ChildStateModel) {
		return state.childForm.model.children;
	}
}
